module.exports = __webpack_public_path__ + "img/792-9f9640.png";